import image1 from '../../assets/programs/engagement_with_parliamentaries/image_1.webp'
import image2 from '../../assets/programs/engagement_with_parliamentaries/image_2.webp'

const grip_data = {
    "title": "Engagement with Parliamentarians",
    "description": "The focus of this engagement is to discuss key technological advancements and policy recommendations with Indian Parliamentarians. Proposed topics include Green Technology & Sustainable Environment, promoting eco-friendly solutions; Quantum Technology & Cybersecurity, highlighting the role of quantum advancements in strengthening security; and Building India's Semiconductor Ecosystem, aimed at boosting India's self-reliance in semiconductor manufacturing. The session takes place at the Parliament Annexe and the program provides a platform for meaningful dialogue between academia and policymakers on critical technologies shaping India's future.",
    "content": [
        {
            "primaryHeading": "",
            "subContent": [
                {
                    "secondaryHeading": "",
                    "description": "",
                    "images": [
                        {
                            "src": image1,
                            "desc": ""
                        },
                        {
                            "src": image2,
                            "desc": ""
                        }
                    ]
                }
            ]
        }
    ]
}

export default grip_data;